<div class="page-layout carded left-sidenav toolbar-fixed-layout">
<!--    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">-->
<!--        <div class="flex flex-col grid-toolbar-buttons-group-container w-p-100 justify-center items-start">-->
<!--            <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>-->
<!--        </div>-->
<!--    </div>-->
    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center toolbar-2">

<!--        <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container">-->
<!--            <label class="component-label"> Actions</label>-->

<!--            <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">-->
<!--                <div class="button-container flex flex-row justify-start items-center">-->
<!--                    <button mat-button class="orbitax-flat-button" (click)="reportSettings()" particleAnalytics-->
<!--                            analyticsCategory="entity-transactions-content" analyticsAction="add-section">Edit Report-->
<!--                    </button>-->
<!--                    <div class="toolbar-separator"></div>-->
<!--                </div>-->
<!--                <div class="button-container flex flex-row justify-start items-center">-->
<!--                    <button mat-button class="orbitax-flat-button" (click)="exportReport()" particleAnalytics-->
<!--                            analyticsCategory="entity-transactions-content" analyticsAction="add-section">Export (.xlsx)-->
<!--                    </button>-->
<!--                    <div class="toolbar-separator"></div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->


        <div class="filter-group-buttons-container flex flex-row">
            <div *ngIf="this.reportModel?.rateType != 'SpotRate'" class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Rate Formats</label>
                <div class="flex flex-row justify-start items-start">
                    <span *ngIf="this.reportModel?.fxRateFormats?.includes('MultiplyBy')">Multiply By </span>
                    <span
                            *ngIf="this.reportModel?.fxRateFormats?.includes('MultiplyBy') && this.reportModel?.fxRateFormats.includes('DivideBy')"
                            class="divider">|</span>
                    <span *ngIf="this.reportModel?.fxRateFormats?.includes('DivideBy')">Divide By</span>
                </div>
            </div>


            <div class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Rate Type</label>
                <span *ngIf="this.reportModel?.rateType==='TaxYearRate'">Tax Year Rate</span>
                <span *ngIf="this.reportModel?.rateType==='PeriodRate'">Period Rate</span>
                <span *ngIf="this.reportModel?.rateType==='SpotRate'">Spot Rate</span>
            </div>

            <div *ngIf="this.reportModel?.rateType==='TaxYearRate'" class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Tax Year End</label>
                <span
                        *ngIf="this.reportModel && this.reportModel.dates && this.reportModel.dates.length">{{this.reportModel?.dates[0] | date: 'dd MMM yyyy' }} </span>
            </div>

            <div *ngIf="this.reportModel?.rateType==='PeriodRate'" class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Start Date</label>
                <span
                        *ngIf="this.reportModel && this.reportModel.dates && this.reportModel.dates.length">{{this.reportModel?.dates[0] | date: 'dd MMM yyyy' }} </span>
            </div>

            <div *ngIf="this.reportModel?.rateType==='PeriodRate'" class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">End Date</label>
                <span
                        *ngIf="this.reportModel && this.reportModel.dates && this.reportModel.dates.length">{{this.reportModel?.dates[1] | date: 'dd MMM yyyy' }} </span>
            </div>

            <div class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Reporting Currencies</label>
                <span>{{ reportingCurrencies }}</span>
            </div>

            <div class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Translation Currencies</label>
                <span>{{ translationCurrencies }}</span>
            </div>

            <div *ngIf="this.reportModel?.rateType !='SpotRate'" class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Rate View (Summary)</label>
                <span>{{ this.reportModel?.summaryRateView }}</span>
            </div>

            <div *ngIf="this.reportModel?.rateType !='SpotRate'" class="filter-button-item" particleAnalytics
                 analyticsCategory=""
                 analyticsAction=""
                 analyticsName="">
                <label class="component-label m-b-5">Rate View (Detailed Fx Rates)</label>
                <span>{{ this.reportModel?.detailRateView }}</span>
            </div>
        </div>

        <div class="responsive-filter-group-buttons-container hide">
            <button mat-button [matMenuTriggerFor]="userMenu"
                    class="user-button">
                <div class="flex flex-row justify-center items-center">
                    <span class="username mr-12">Report Settings</span>
                    <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <button *ngIf="this.reportModel?.rateType != 'SpotRate'" mat-menu-item
                        class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="countries-filter">
                        <div class="flex flex-col justify-center"><label class="component-label m-b-5">Rate Formats</label>
                            <div class="lineHeightNormal">
                                <span *ngIf="this.reportModel?.fxRateFormats?.includes('MultiplyBy')">Multiply By </span>
                                <span
                                        *ngIf="this.reportModel?.fxRateFormats?.includes('MultiplyBy') && this.reportModel?.fxRateFormats.includes('DivideBy')"
                                        class="divider">|</span>
                                <span *ngIf="this.reportModel?.fxRateFormats?.includes('DivideBy')">Divide By</span>
                            </div></div>

                </button>

                <button mat-menu-item class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="countries-filter">
                    <div class="flex flex-col justify-center">
                        <label class="component-label m-b-5">Rate Type</label>
                        <div class="lineHeightNormal">
                            <span></span>
                            <span *ngIf="this.reportModel?.rateType==='TaxYearRate'">Tax Year Rate</span>
                            <span *ngIf="this.reportModel?.rateType==='PeriodRate'">Period Rate</span>
                            <span *ngIf="this.reportModel?.rateType==='SpotRate'">Spot Rate</span>
                        </div>
                    </div>
                </button>
                <button mat-menu-item class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        *ngIf="this.reportModel?.rateType==='PeriodRate'"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="date-range-filter">
                        <div class="flex flex-col justify-center"><label class="component-label m-b-5">Start Date</label>
                            <div class="lineHeightNormal">
                    <span
                            *ngIf="this.reportModel && this.reportModel.dates && this.reportModel.dates.length">{{this.reportModel?.dates[0] | date: 'dd MMM yyyy' }} </span>
                            </div></div>

                </button>

                <button mat-menu-item class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        *ngIf="this.reportModel?.rateType==='PeriodRate'"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="all-incorpration-edit">
                    <div class="flex flex-col justify-center">

                        <label class="component-label m-b-5">End Date</label>
                        <div class="lineHeightNormal">
            <span
                    *ngIf="this.reportModel && this.reportModel.dates && this.reportModel.dates.length">{{this.reportModel?.dates[1] | date: 'dd MMM yyyy' }} </span>
                        </div>
                    </div>

                </button>
                <button mat-menu-item class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="all-incorpration-edit">
                        <div class="flex flex-col justify-center"><label class="component-label m-b-5">Reporting Currencies</label>
                            <div class="lineHeightNormal">
                                <span>{{ reportingCurrencies }}</span>
                            </div></div>

                </button>

                <button mat-menu-item class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="all-incorpration-edit">
                        <div class="flex flex-col justify-center"><label class="component-label m-b-5">Translation Currencies</label>
                            <div class="lineHeightNormal">
                                <span>{{ translationCurrencies }}</span>
                            </div></div>

                </button>

                <button mat-menu-item class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        *ngIf="this.reportModel?.rateType !='SpotRate'"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="all-incorpration-edit">
                        <div class="flex flex-col justify-center"><label class="component-label m-b-5">Rate View (Summary)</label>
                            <div class="lineHeightNormal">
                                <span>{{ this.reportModel?.summaryRateView }}</span>
                            </div></div>

                </button>

                <button mat-menu-item class="flex flex-col justify-center" style="height:3.2rem!important;align-items:flex-start;"
                        *ngIf="this.reportModel?.rateType !='SpotRate'"
                        particleAnalytics
                        analyticsCategory="taxnews-content"
                        analyticsAction="all-incorpration-edit">
                        <div class="flex flex-col justify-center"><label class="component-label m-b-5">Rate View (Detailed Fx Rates)</label>
                            <div class="lineHeightNormal">
                                <span>{{ this.reportModel?.detailRateView }}</span>
                            </div></div>

                </button>

            </mat-menu>
        </div>
    </div>
    <div *ngIf="this.showNote===true" class="notification-message-container flex flex-row justify-between items-center">
        <div>
            <span>Note:</span> <span> Below you will find a summary view of your FX Rates Report. To view the entire report,
      including detailed FX Rates per currency, please <a class="dynamic-link" (click)="exportReport()">Export your FX Rates report</a> (.xlsx)</span>
        </div>
        <button mat-icon-button
                (click)="closeNote()"
                particleAnalytics
                analyticsCategory=""
                analyticsAction="">
            <mat-icon>close</mat-icon>
        </button>
    </div>


    <mat-sidenav-container>

        <!-- CENTER -->
        <!--<div class="center">-->
        <!--&lt;!&ndash; CONTENT CARD &ndash;&gt;-->
        <!--<div class="content-card mat-white-bg">-->
        <!--&lt;!&ndash; CONTENT TOOLBAR &ndash;&gt;-->
        <!-- TODO: m-30 for single tab -->
        <div class="content  pos-relative flex flex-col full-grow-no-shrink-no-basis">
            <div class="keno-grid-container">
                <particle-virtual-grid [sourceKey]="newSourceType" [invalidateSubject]="invalidateSubject"
                                       [showSingleTabHeader]="true"
                                       (valueChanged)="onGridCellValueChange($event)">
                </particle-virtual-grid>
            </div>
        </div>
        <!--</div>-->
        <!--</div>-->

    </mat-sidenav-container>
</div>
